export function initAccordeons() {
  var accordionHeaders = document.querySelectorAll(".accordion-header");
  accordionHeaders.forEach(header => {
    header.addEventListener("click", ()=>{
      const accordionBody = header.nextElementSibling as any;
      if(!accordionBody) return;
      if (header.classList.contains('active')) {
        accordionBody.style.height = '0'
        header.classList.remove("active");
      } else {
        const h = accordionBody.querySelector('.accordion-content').getBoundingClientRect().height
        accordionBody.style.height = h + 'px'
        header.classList.add("active");
      }
    });
  });
}